module.exports = __webpack_public_path__ + "media/images/light_gray_lines_horizontal_big-d797ed0df56405248dc8cceac720c4c0.svg";